import React from 'react'
import defaultEmptyImg from '@/assets/images/empty.png'

interface EmptyStateProps {
  image?: string // 插图路径
  description?: string // 提示文字
  actionText?: string // 操作按钮文字
  offText?: string // 提示文字
  onAction?: () => void // 操作回调
  className?: string // 自定义样式
}

const EmptyState: React.FC<EmptyStateProps> = ({
  image,
  description = '暂无数据',
  actionText,
  offText,
  onAction,
  className = '',
}) => {
  const emptyImg = image || defaultEmptyImg
  return (
    <div
      className={`flex flex-col items-center justify-center py-12`}
    >
      <img
        src={emptyImg}
        alt="empty"
        className={`mb-2 w-[320px] h-[160px] object-contain select-none pointer-events-none ${className}`}
      />
      <div className="flex items-center">
        <div className="text-[14px] text-[#999999]">{description}</div>
        {actionText && (
          <button
            type="button"
            onClick={onAction}
            className="text-[14px] text-[#8047FF] hover:underline focus:outline-none mx-1"
          >
            {actionText}
          </button>
        )}
        {offText && (
          <div className="text-[14px] text-[#999999]">{offText}</div>
        )}
      </div>
    </div>
  )
}

export default EmptyState
